import React from 'react'
import Header from './Header'
import { useState,useEffect } from 'react'
import  axios  from 'axios';
import Recipies from './Recipies';

export default function App() {
    
    const [recipie,setrecipie]=useState([]);
    const APP_ID="47b937f2";
    const APP_KEY="9710d8193381064fd17901fcd54c0bb9";
    const [search,setsearch]=useState("egg");
    useEffect(()=>{
      
     getRecipies();
     // eslint-disable-next-line
    },[]);
    const getRecipies= async()=>{
      const res= await axios.get(`https://api.edamam.com/search?q=${search}&app_id=${APP_ID}&app_key=${APP_KEY}&from=0&to=3&calories=591-722&health=alcohol-free`);
      setrecipie(res.data.hits);
      console.log(res.data);
    }
     
        
    
      
   
   
    function finalsearch(e){
     setsearch(e.target.value)
     console.log(e.target.value)
    }
    function buttonClick(){
      getRecipies();
    }
    
   
  return (
    <>
      <Header lastsearch={finalsearch} firstsearch={search} buttonClick={buttonClick} />
      <Recipies recipie={recipie}></Recipies>
   </>
    
  )
}
